
const FilterConfig = {
    displayMethod: {
        BETWEEN: 'between',
        SELECT_MULTIPLE: 'select_multiple',
        SELECT_SINGLE: 'select_single',
        SINGLE: 'single',
        AREA: 'area',
        RADIUS: 'radius',
        RELATED: 'related',
    },
    dataTypesValidationRules: {
        'int': ['^\-?[0-9]+$'],
        'datetime': ['^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}$'],
        'date': ['^[0-9]{4}-[0-9]{2}-[0-9]{2}$'],
        'bool': ['^(true|false)$'],
        'double': ['^\-?[0-9]+(\.[0-9]+)?$'],
        'string': ['^.+$'],
        'array': ['^.+$'],
    },
    filtersForAttribute: {
        'geom': ['area', 'radius']
    }
}


export default FilterConfig;
